import React from 'react';
import Modal from 'react-modal';
import { connect } from 'react-redux';
import Icon from '../../../Components/Icon';
import './LockPayment.scss';

const LockPaymentFailed = ({ onChange, isModalOpen }) => {
   const PaymentFailedMessage = () => {
      return (
         <>
            <div className="fit-modal-body">
               <Icon
                  className="material-icons large-icon red-text"
                  iconName="error_outline"
               />
               <h4>Payment Failed</h4>
               <p>
                  Unfortunately, your payment could not be
                  processed. This may have happened because:
               </p>
               <ul style={{ textAlign: 'left', marginLeft: '40px' }}>
                  <li>The payment was cancelled</li>
                  <li>Insufficient funds in your account</li>
                  <li>An error occurred with the payment provider</li>
                  <li>Your session timed out</li>
               </ul>
               <p>
                  Please try again or contact us if the problem persists.
               </p>
            </div>
            <div className="close-modal-button">
               <button
                  type="button"
                  className="close-payment-button waves-effect waves-light"
                  onClick={() => onChange()}
               >
                  CLOSE
               </button>
            </div>
         </>
      );
   };

   return (
      <>
         <Modal
            isOpen={isModalOpen}
            onRequestClose={() => {
               onChange();
            }}
            className="delete-modal"
            overlayClassName="generic-modal-overlay"
            appElement={document.getElementById('root')}
         >
            <Icon
               className="fit-model-icon material-icons right"
               iconName="close"
               onClick={() => onChange()}
            />
            <br />

            {<PaymentFailedMessage />}
         </Modal>
      </>
   );
};

LockPaymentFailed.propTypes = {};

const mapStateToProps = state => {
   return {};
};

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(LockPaymentFailed);
